
import { createRouter, createWebHistory } from 'vue-router'


import Blog from '@/Views/Blog.vue'
import Blogs from '@/Views/Blogs.vue'

import Event from '@/Views/Event.vue'
import Events from '@/Views/Events.vue'

import Feed from '@/Views/Feed.vue'
import Auth from '@/Views/Auth.vue'

import Chats from '@/Views/Chats.vue'
import Chat from '@/Views/Chat.vue'

import User from '@/Views/User.vue'
import Cards from '@/Views/Cards.vue'

import Tag from '@/Views/Tag.vue'

import Agreement from '@/Views/docs/Agreement.vue'
import Help from '@/Views/docs/Help.vue'


import Terms from '@/Views/docs/Terms.vue'
import Help2 from '@/Views/docs/Help2.vue'

const routes = [
  {
    path: '/blog/:id?',
    name: 'blog',
    component: Blog
  },
  {
    path: '/u/:user?',
    name: 'user',
    component: User,
    props: { full: true }
  },
  {
    path: '/t/:tag?',
    name: 'tag',
    component: Tag
  },
  {
    path: '/feed',
    name: 'feed',
    component: Feed
  },
  {
    path: '/auth/',
    component: Auth,
    name: 'auth',
    // children: [
    //   {
    //     path: 'l',
    //     name: 'login',
    //     component: Login,
    //   },
    //   {
    //     path: 's',
    //     name: 'signup',
    //     component: Signup,
    //   },
    // ],
    props: { full: true }
  },
  // {
  //   path: '/login',
  //   name: 'login',
  //   component: Login
  // },
  // {
  //   path: '/signup',
  //   name: 'signup',
  //   component: Signup
  // },
  {
    path: '/agreement',
    name: 'agreement',
    component: Agreement
  },
  {
    path: '/terms',
    name: 'terms',
    component: Terms,
    props: { single: true }
  },
  {
    path: '/help',
    name: 'help',
    component: Help
  },
  {
    path: '/help2',
    name: 'help2',
    component: Help2,
    props: { single: true }
  },
  {
    path: '/',
    name: 'index',
    component: Blogs
  },
  {
    path: '/blogs',
    name: 'blogs',
    component: Blogs
  },
  {
    path: '/event/:id?',
    name: 'event',
    component: Event
  },
  {
    path: '/chats/',
    name: 'chats',
    component: Chats,
  },
  {
    path: '/chat/:id?',
    name: 'chat',
    component: Chat,
    props: { full: true, hideNav: true }
  },
  {
    path: '/events',
    name: 'events',
    component: Events
  },
  {
    path: '/cards',
    name: 'cards',
    component: Cards
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior (to) {
    if (!to.params.stopScroll) {
      return {
        left: 0,
        top: 0
      }
    }
  }
})

export default router;
